/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import Label from "../../../components/label";
import { NavLink } from "react-router-dom";
import appRoutes from "../../../routes/appRoutes";
import TicketEditForm from "../../../containers/TicketsUpdateForm";
import MakeAPICall from "../../../apiCalls/common";
import { adminAction, doctorNotes, getTicketById, resolved, updateTicket } from "../../../apiRoutes";
import Model from "../../../components/modal";


class EditTicketPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      apiCall: null,
      ticketData : null,
      apiResponceModelOpen: false,
      apiResponceModelTitle: "Instant Consult",
      apiResponceModelBody: ""
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getTicketData(this.props.location?.state?._id);
  };

  ticketEditSubmit = (formValues, isDoctorNotesChanged) => {
    console.log("Sign up form submitted : ", formValues);
    let apiCallParam = {
      reqType: "PUT",
      reqURL: updateTicket + "/" + this.state.ticketData._id,
      dataObj: {
        doctorNotes: formValues.doctorNotes,
        isDoctorNotesUpdated: isDoctorNotesChanged
      },
      params: {},
      headers: {},
      successCallback: res => {        
        this.setState({
          apiResponceModelBody: "Ticket Updated Successfully",
          apiResponceModelOpen: true
        });
      },
      failureCallback: err => {
        console.log("Got the error : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  notifySupportSubmit = (props, status, isDoctorNotesChanged) => {
    let apiCallParam = {
      reqType: "PUT",
      reqURL: updateTicket + "/" + this.state.ticketData._id,
      dataObj: {
        doctorNotes: props.doctorNotes ? props.doctorNotes : "",
        status: status,
        isDoctorNotesUpdated: isDoctorNotesChanged
      },
      params: {},
      headers: {},
      successCallback: res => {        
        // this.setState({
        //   apiResponceModelBody: "Ticket Updated Successfully",
        //   apiResponceModelOpen: true
        // });
      },
      failureCallback: err => {
        console.log("Got the error : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  markadminAction = (_id, notes, noteId) => {
    let apiCallParam = {
      reqType: "POST",
      reqURL: adminAction,
      dataObj: {
        ticketId: _id,
        doctorNote: notes,
        doctorNoteId: noteId
      },
      successCallback: res => {        
        this.getTicketData(_id)
      },
      failureCallback: err => {
        console.log("Got the error : ", err);
      },
    };
    this.setState({ apiCall: apiCallParam });
  };

  resolvedadminAction = (_id, noteId) => {
    let apiCallParam = {
      reqType: "POST",
      reqURL: resolved,
      dataObj: {
        ticketId: _id,
        doctorNoteId: noteId
      },
      successCallback: res => {        
        this.getTicketData(_id)
      },
      failureCallback: err => {
        console.log("Got the error : ", err);
      },
    };
    this.setState({ apiCall: apiCallParam });
  };

  addNotes = (_id, notes, followUpRequired, nilActionRequired) => {
    let apiCallParam = {
      reqType: "POST",
      reqURL: doctorNotes,
      dataObj: {
        ticketId: _id,
        doctorNote: notes,
        hasFollowupRequired: followUpRequired,
        hasNilAction: nilActionRequired
      },
      params: {},
      headers: {},
      successCallback: res => {
        this.getTicketData(_id)
      },
      failureCallback: err => {
        console.log("Got the error : ", err);
      },
    };
    this.setState({ apiCall: apiCallParam });
  };

  getTicketData = (id) => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: getTicketById,
      dataObj: {},
      params: {
        ticketId: id
      },
      headers: {},
      successCallback: res => {
        this.setState({
          ticketData: res.data.data
        })
      },
      failureCallback: err => {
        console.log("Got the error : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  closeAPIResponceModel = () => {
    this.setState({
      apiResponceModelOpen: false
    });
    this.props.history.push(appRoutes.tickets);
  }

  render() {
    return (
      <div className="row rounded p-3 ticket-edit-page">
        <div className="col-sm-6 p-3">
          <NavLink
            to={appRoutes.tickets}
            className="insta-link-orange font-15 text-decoration-none"
            href="#"
          >
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 pt-1 back-btn-text"> Back to Tickets</span>
          </NavLink>
        </div>
        <div className="col-sm-12">
          <Label title="Update Ticket Details" className="big" />
        </div>
        <div className="col-sm-12 border-bottom mt-3"></div>
        <div className="col-sm-12 pt-3">
          <TicketEditForm onFormSubmit={this.ticketEditSubmit} markadminAction={this.markadminAction} resolvedadminAction={this.resolvedadminAction} addNotes={this.addNotes} ticketData={this.state.ticketData} userData={this.props.userData} />
        </div>
          {/* API Call */}
          <MakeAPICall apiParam={this.state.apiCall} />

{/* API Responce Custom Model */}
        <Model
          openModal={this.state.apiResponceModelOpen}
          modalBodyContent={this.state.apiResponceModelBody}
          okayText="Okay"
          cancelText="Okay"
          title={this.state.apiResponceModelTitle}
          useOneButton={true}
          okayEvent={this.closeAPIResponceModel}
          cancelEvent={this.closeAPIResponceModel}
        />
      </div>
    );
  }
}

// export default EditTicketPage;
const mapStateToProps = props => ({
  userData:
    props.auth && props.auth.user && props.auth.user.userData
      ? props.auth.user.userData
      : {}
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditTicketPage);
